import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { DashboardViewType } from '@shared/enums/dashboard-view-type';
import { RouteData } from '@shared/enums/route-data';
import { RoutePath } from '@shared/enums/route-path.enum';
import { AuthGuard } from '@shared/guards/auth.guard';
import { ResidentGuard } from '@shared/guards/resident.guard';

import { MainApplicationComponent } from './main-application.component';

const routes: Routes = [
  {
    path: '',
    component: MainApplicationComponent,
    children: [
      {
        path: RoutePath.RESIDENT,
        canActivate: [AuthGuard],
        loadChildren: () => import('@main-application/resident/resident.module').then(m => m.ResidentModule),
      },
      {
        path: '',
        canActivate: [AuthGuard, ResidentGuard],
        loadChildren: () =>
          import('@main-application/application-menu/application-menu.module').then(m => m.ApplicationMenuModule),
      },
      {
        path: RoutePath.NO_PERMISSION,
        canActivate: [AuthGuard],
        data: {
          [RouteData.BREADCRUMB]: 'No permission',
          [RouteData.DASHBOARD_VIEW_TYPE]: DashboardViewType.NONE,
        },
        loadComponent: () =>
          import('@main-application/no-permission/no-permission.component').then(m => m.NoPermissionComponent),
      },
      {
        path: RoutePath.NO_PACKAGE,
        canActivate: [AuthGuard],
        data: {
          [RouteData.BREADCRUMB]: 'No package',
          [RouteData.DASHBOARD_VIEW_TYPE]: DashboardViewType.NONE,
        },
        loadComponent: () =>
          import('@main-application/no-package/no-package.component').then(m => m.NoPackageComponent),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MainApplicationRoutingModule {}
